export default __webpack_public_path__ + "static/media/logoiac.479d543a.png";